import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { _ } from '_locales';

import { primaryColor } from '_apis';
import { colors } from '_styles';

const Container = styled.div`
  position: relative;
`;

const ItemButton = styled.button`
  all: initial;
  font-family: Roboto, sans-serif !important;
  display: inline-block; 
  background: none;
  border: none;
  font-size: inherit !important;
   
  background: none;
  border: none;
  outline: none;
  height: auto;
  overflow: hidden;
  max-height: 100%;
  padding: 2px;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }

  width: 100%;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 10px -2px #ccc;
  margin: 0 auto;
  margin-bottom: 10px;
  cursor: pointer;
  text-align: left;

  &:last-child {
    margin-bottom: 20px;
  }
`;

const InnerItemButton = styled.div`
  cursor: pointer;
  display: inline-block;
  position: relative;

  ${ItemButton}:focus > & {
    box-shadow: 0 0 2px 2px #51a7e8;
    border-radius: 5px;
  }

  &:focus {
    outline: none;
  }
  padding: 15px;
  box-sizing: border-box;
  width: 100%;
  &::-moz-focus-inner {
    border: 0;
  }
`;

const Location = styled.div`
  font-size: 12px !important;
   
  line-height: 1.7em !important;

    p {
      line-height: 1.6em;
      font-size: 14px !important;
       
      color: #595959;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 10px 0;
    }

    title {
      display: block !important;
      font-size: 16px !important;
      font-weight: 400 !important;
      align-self: center;
      font-weight: 200 !important;
      margin-bottom: 10px;
    }

    b {
      font-weight: bold !important;
    }

    a {
      color: ${colors.RC_ACTION} !important;
      text-decoration: none !important;

      &:hover {
        color: ${colors.RC_ACTION} !important;
        text-decoration: none !important;
      }
    }
`;

const ActiveSign = styled.div`
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 10px;
  background-color: ${colors.RC_ACTION};
  float: left;
  margin: 4px 8px 0 0;
`;

const DetailsLink = styled.button`
  all: initial;
  font-family: Roboto, sans-serif !important;
  display: inline-block; 
  background: none;
  border: none;
  outline: none;
  color: ${colors.RC_ACTION}!important;
  font-size: 15px !important;
  position: absolute;
  bottom: 20px;
  right: 15px;
  font-weight: 600 !important;


  text-decoration: none !important;

  &:hover {
    text-decoration: none !important;
  }

  &:focus {
    outline: none;
  }
`;

const InnerDetailsLink = styled.span`
  cursor: pointer;
  display: inline-block;
  position: relative;
  padding: 0 15px !important;

  ${DetailsLink}:focus > & {
    box-shadow: 0 0 2px 2px #51a7e8;
    border-radius: 5px;
  }

  &:focus {
    outline: none;
  }
`;

const Text = styled.h4`
  font-size: 16px !important;
   
  font-weight: 400 !important;
  margin: 0;
  margin-bottom: 12px;
  display: inline;
`;

const Event = ({
  itemKey, title, details, itemClickHandler, activeId, detailsClickHandler
}) => (
  <Container>
    <ItemButton
      tabIndex="0"
      primaryColor={primaryColor}
      aria-label="select to see the event's location"
      onClick={() => ((activeId !== itemKey) ? itemClickHandler() : detailsClickHandler())}
    >
      <InnerItemButton tabIndex="-1">
        {
          activeId === itemKey
            ? (<ActiveSign />)
            : null
        }
        <Text>{title}</Text>
        {
          details ? (<Location>{parse(details)}</Location>) : null
        }
      </InnerItemButton>
    </ItemButton>

    <DetailsLink tabIndex="0" onClick={detailsClickHandler} alt="check the details" title="event details">
      <InnerDetailsLink tabIndex="-1">{_('wgw.details')}</InnerDetailsLink>
    </DetailsLink>
  </Container>
);

export default Event;
